import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { useStore } from "csi/state/hooks";
import { clickableStyle, STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { useCallback } from "react";
import { Virtuoso } from "react-virtuoso";
import CommentSummaryCard from "./CommentSummaryCard";

const PREFIX = "CommentsList";

const classes = {
	root: `${PREFIX}root`,
};

const StyledBox = styled(Box)((
	{
		theme,
	},
) => ({
	[`& .${classes.root}`]: {
		...clickableStyle(theme),

		// overflow necessary since each card contains Grid that has width over 100%
		overflow: "hidden",

		"&:not(:last-child)": {
			borderBottom: STANDARD_BORDER_STYLE,
		},
	},
}));

export const CommentsList = observer(() => {
	const { commentsStore, commentsStore: { filteredComments } } = useStore();

	/** handle the card onclick */
	const handleClick = (url) => (event) => {
		// user would input the link through the editor,
		// when clicking on the link, just stay where we are
		if ((event.target as HTMLAnchorElement).nodeName === "A") {
		  return;
		}
		commentsStore.selectCommentByUrl(url);
	};

	function itemContent(_, commentUrl) {
		return (
			<CommentSummaryCard
				className={classes.root}
				commentUrl={commentUrl}
				onClick={handleClick(commentUrl)}
			/>
		);
	}

	return (
		<StyledBox display="flex" flexGrow={1}>
			<Virtuoso
				data={filteredComments}
				itemContent={itemContent}
				style={{ height: "100%", width: "100%" }}
			/>
		</StyledBox>
	);
});

export default CommentsList;